import { Avatar } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { makeSelectBank } from '@/model/dictionary/selectors';
import { Transaction } from '@/model/wallets/types';
import { ReactComponent as CardIcon } from '@/pages/wallets/components/TransactionsPageView/icons/card.svg';
import { ReactComponent as SBPIcon } from '@/pages/wallets/components/TransactionsPageView/icons/sbp.svg';
import { ReactComponent as UnknownIcon } from '@/pages/wallets/components/TransactionsPageView/icons/unknown.svg';

export interface TransactionIconProps {
  'data-test'?: string;
  value: Transaction;
}

export const TransactionIcon: React.FC<TransactionIconProps> = ({ value, 'data-test': dataTest }) => {
  const bankId = value.sbpInfo?.bankId || value.cardInfo?.bankId;
  const selectBank = useMemo(() => (bankId ? makeSelectBank(bankId) : (): undefined => undefined), [bankId]);
  const bank = useSelector(selectBank);
  if (value.sbpInfo) {
    return (
      <span data-test={dataTest}>
        <SBPIcon />
      </span>
    );
  }
  if (bank) {
    return <Avatar data-test={dataTest} src={bank.icon} alt={bank.name} />;
  }
  if (value.cardInfo) {
    return (
      <span data-test={dataTest}>
        <CardIcon />
      </span>
    );
  }
  return (
    <span data-test={dataTest}>
      <UnknownIcon />
    </span>
  );
};

export default TransactionIcon;
